import { AppLayout } from '@/components/app-layout';
import { AppSumoGate } from '@/components/appsumo-gate.component';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { RecordsTabsHeader } from '@/components/sidebar/tabs/records-tabs.component';
import { PeopleListContainer } from '@/containers/people/people-list-container.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/people/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Head heading='People' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <RecordsTabsHeader />
            <AppSumoGate label='People'>
              <PeopleListContainer />
            </AppSumoGate>
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
